import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MaintenancePanelBar } from 'components/features/MaintenancePanelBar/MaintenancePanelBar';
import { DeviceChartView } from '../DeviceChartView';
import {
  getSingleDevice,
  doFetchAlarms,
  storeAllDeviceAlarms,
  updatePivotOverviewPageSingleSelectedDevice,
  updateEchoOverviewPageSelectedDevice
} from 'redux/actions';
import { Status } from 'common/utils/constants';
import './DeviceDetailsPanel.css';

const DeviceDetailsGa2Panel = ({ device, donorDevice, deviceType, isGa2 }) => {
  const fetchAlarmsStatus = useSelector((store) => store.statuses.fetchAlarms);
  const statuses = useSelector((store) => store.statuses == null);
  const dispatch = useDispatch();
  const pollDeviceTimeout = useRef(null);
  const suId = device?.id;
  const donorId = donorDevice?.id;

  const handleFetchAlarms = (deviceId) => {
    if (fetchAlarmsStatus == null && deviceId) {
      dispatch(
        doFetchAlarms(
          [deviceId], // deviceIDs,
          null,
          null,
          ['active'],
          null,
          null,
          1000,
          null,
          ['severity'],
          (result) => {
            dispatch(storeAllDeviceAlarms(result));
          },
          (error) => {
            console.log('doFetchAlarmsError', error);
          },
          []
        )
      );
    }
  };

  const handleGetSingleDevice = (deviceId) => {
    if (statuses['GET-' + deviceId] !== Status.PENDING) {
      dispatch(
        getSingleDevice(deviceId, (result) => {
          if (deviceType === 'echo') {
            dispatch(updateEchoOverviewPageSelectedDevice(result));
          } else {
            dispatch(updatePivotOverviewPageSingleSelectedDevice(result));
          }
        })
      );
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(pollDeviceTimeout.current);
    };
  }, []);

  useEffect(() => {
    handleGetSingleDevice(donorId);
    handleFetchAlarms(suId);

    //clear timer
    if (pollDeviceTimeout.current != null) clearInterval(pollDeviceTimeout.current);

    //and poll duh
    pollDeviceTimeout.current = setInterval(() => {
      handleGetSingleDevice(donorId);
      handleFetchAlarms(suId);
    }, 15000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suId, donorId]);

  return (
    <div id="DeviceDetailsPanelContainer">
      <div className="DeviceDetailsPanel_MaintenanceBar_Div">
        {/* Sending GA2Version as it is required for BLINK LED for SUs */}
        <MaintenancePanelBar source={'details'} isGa2={isGa2} targetDevice={device} targetDeviceType={deviceType} ga2IBMSVersion={donorDevice?.properties?.reported?.['ga2-ibms-api-version']}/>
      </div>
      <div className="rowFlexDiv">
        <div style={{ flex: '1 1 0%', margin: '0px 0px 16px 0px', maxWidth: '100%' }}>
          <DeviceChartView deviceId={suId} />
        </div>
      </div>
    </div>
  );
};

export default DeviceDetailsGa2Panel;
